module.exports = __webpack_public_path__ + "3370f543c4bc4ef363fcd05174d31e97.svg";